// Copyright 2024 Sorama B.V.

// Extend webapi Point3D to check if equal
import { Point3D } from "datatypes/SoramaWebApi";

export class Point3DExtension {
    public static Point3DDelta = 1e-6; // use 1 um as minimum

    public static Equals(a: Point3D, b: Point3D): boolean {
        const delta = Point3DExtension.Point3DDelta;
        return a == null || b == null
            ? false
            : Math.abs(a.x - b.x) < delta && Math.abs(a.y - b.y) < delta && Math.abs(a.z - b.z) < delta;
    }
}
